import { Block, Work, Project, Contact, useNavi, useInfo } from "./components"
import { LanguageIcon, MailIcon, GithubIcon, PhoneIcon } from "./icons"

export default function ResumeZH() {
  const navi = useNavi()
  const info = useInfo()
  return (
    <>
      <LanguageIcon className="lang" onClick={() => navi("/en")} />
      <h1>姚先生的个人简历</h1>

      <Block title="个人信息">
        {info && <p>姓名：姚博</p>}
        <p>学历：本科 - 计算机科学与技术</p>
        <p>从业经验：15 年</p>
        <p>求职意向：全栈开发 / AI 应用开发 / 前端开发</p>
      </Block>
      <Block title="联系方式">
        {info && <Contact icon={<PhoneIcon />}>180-1279-5566</Contact>}
        <Contact icon={<MailIcon />}>abelyao@live.com</Contact>
        <Contact icon={<GithubIcon />}>
          <a href="https://github.com/yb" target="_blank">
            https://github.com/yb
          </a>
        </Contact>
      </Block>
      <Block title="工作技能">
        <p>主要技能：TypeScript, React, Vue, Node.js</p>
        <p>常用框架：Next.js, AI-SDK, Nuxt, Fastify, Shadcn UI</p>
        <p>其它技能：MongoDB, Redis, Nginx</p>
      </Block>
      <Block title="工作经验">
        <Work
          company="摩派分子"
          title="Agent 全栈工程师"
          start="2026年2月"
          end="至今"
        >
          <p>
            独立完成了公司核心 Agent
            产品的前端设计与开发，同时参与了部分后端接口开发。该产品基于 React
            Router 与 TypeScript
            构建，实现了完善的流式对话交互、任务空间管理、多种格式在线预览、DAG
            Graph
            可视化、项目成员管理、钱包充值和套餐订阅等功能。并实现了标准版与企业版双版本分发设计。
          </p>
          <p>
            该项目大量使用 Claude Code、Codex、Cursor 等工具进行 vibe coding
            开发，实现了从概念到初版产品的快速上线交付。
          </p>
        </Work>
        <Work
          company="德锐特成像技术"
          title="软件工程师"
          start="2024年9月"
          end="2025年10月"
        >
          <p>
            使用 React 和 Electron 开发了一款 4D-STEM 分析客户端。该软件通过调用
            Python 分析算法进行数据处理与可视化，并集成在线更新功能，同时通过
            i18next 支持多语言界面。此外，开发了一款机台状态监控软件，通过 RPC
            接口实时获取机台状态，可在数值超出设定阈值时自动向邮箱和企业微信发送告警通知。
          </p>
        </Work>
        <Work
          company="象帝先计算技术"
          title="软件工程师"
          start="2023年1月"
          end="2024年9月"
        >
          <p>
            使用 React、Vue、Electron、X6、ECharts
            等前端技术，开发用于任务流程管理、数据分析与电路设计等多个方向的芯片设计相关软件。日常职责涵盖前端技术选型、初级开发人员指导，并参与部分项目的整体架构设计。
          </p>
          <p>
            参与开发良率数据采集与监控平台，在代工厂设备上部署数据采集程序，将良率等关键指标回传至中心服务器，实现产线预警、良率报告与可视化展示。
          </p>
        </Work>
        <Work
          company="硅康医药"
          title="高级前端工程师"
          start="2020年5月"
          end="2022年7月"
        >
          <p>
            作为团队中第一位网站开发者，我与 R&D
            团队协作，负责开发具备数据图表及 2D/3D 分子显示能力的可视化 Web
            平台。该平台将科学计算工具与功能以可视化形式集成，通过丰富的前端交互，直观高效地呈现计算报告，助力用户便捷处理数据。
          </p>
          <p>
            技术栈方面，采用 React 和 Ant Design 作为前端框架，通过 RDKit 和 NGL
            viewer 绘制 2D/3D 分子结构，使用 Plotly.js 展示数据图表；以 Egg.js
            和 Sequelize ORM 作为后端框架。另外，还使用 Next.js
            开发了计算集群资源使用率监控网站。
          </p>
        </Work>
        <Work company="独立开发者" title="全栈开发" start="2017年" end="2020年">
          <p>
            出于对代码的热爱，我于 2017
            年尝试创业并成为一名全栈工程师。期间独立完成了多个网站、微信公众号及小程序应用。同时在
            GitHub 分享开源项目，并获得了 1400+ stars
            的认可。我一直保持学习新的技能，从前端到后端，以丰富我的技能树，并从中享编程的快乐。
          </p>
        </Work>
        <Work
          company="金百汇信息科技"
          title="软件工程师"
          start="2012年4月"
          end="2015年2月"
          onlyFull
        >
          <p>使用 ASP.NET 和 SQL Server 开发多商户电商平台</p>
          <p>
            使用 C# 和 SQL Server
            为汕头市体育局开发了赛事报名系统、运动员管理系统、官方网站等
          </p>
        </Work>
        <Work
          company="蓝凌科技"
          title="软件工程师"
          start="2011年4月"
          end="2012年3月"
          onlyFull
        >
          <p>使用 ASP.NET 为中国移动某分公司开发市场营销平台</p>
          <p>使用 ASP.NET 为中国移动某分公司开发 OA 系统和通用业务组件</p>
        </Work>
      </Block>
      <Block title="个人项目">
        <Project name="IMAGEN" desc="微信小程序">
          <p>
            IMAGEN
            是一款图片生成工具，用户通过自然语言描述并上传参考图，即可生成多风格的高质量图片。其内置
            GPT 4o、 GPT Image 2、Nano Banana Pro、Seedream 等多种主流图片模型。
          </p>
          <p>
            该项目的亮点是采用 Agent 思路做任务路由与参数编排，使用 LLM
            将用户输入拆解为原子化任务，并智能匹配参数组合，减少复杂的表单操作。后端基于
            Fastify + BullMQ
            构建异步任务队列，以轮询机制保障图片生成的稳定性，并自动下载结果转存至阿里云
            OSS，提高用户访问速度，同时避免占用服务器带宽。
          </p>
        </Project>
        <Project name="Firefly">
          <p>
            Firefly 是一个通用型的在线 Agent 平台。它主要基于 AI-SDK
            构建，实现了完整的流式事件处理，包括刷新恢复续传、工具执行展示和审批、自定义事件推送等。
            Agent 通过 ToolLoopAgent 驱动，内置网络搜索、网页获取、Bash
            命令等基础工具，并基于 Docker
            实现了沙箱执行环境，具有文件读写和执行的能力。 平台还采用 BullMQ
            实现了分布式任务队列，优化长任务的执行稳定性，并支持状态追踪与进度实时反馈。
          </p>
        </Project>
        <Project
          name="Fotodata"
          desc={
            <a href="https://fotodata.app/" target="_blank">
              https://fotodata.app/
            </a>
          }
        >
          <p>
            Fotodata
            是一个在线分析照片数据的工具，它无需安装软件、也不需要将照片上传至服务器，在浏览器里即可对
            200 多种相机型号的 RAW
            格式的照片进行解析，并生成折线图、饼图、柱状图等多维度统计图表。它通过
            Web Worker 和 WebAssembly 进行性能优化，分析 40000
            多张照片也只需半小时。此外，该项目还曾发布到 Product Hunt 进行推广。
          </p>
        </Project>
        <Project name="H5Cafe" desc="微信公众号">
          <p>
            凭借一款 H5 小游戏，最高单日访问量超过 6,000,000 PV，500,000
            UV，100,000 人同时在线，以及 600 GB 流量，在半年内它为公众号带来 18
            万粉丝。该项目仅依托一台 4GB 内存的 Windows Server
            服务器，通过前后端分离技术，搭配 CDN 分发静态资源以减少服务器的 HTTP
            请求次数，并引入 Redis 缓存部分数据以降低 SQL Server
            的负载。同时接入微信支付，实现在线充值功能。
          </p>
        </Project>
      </Block>
      <Block title="教育背景">
        <p>本科：华中科技大学 - 计算机科学与技术</p>
        <p>专科：汕头大学 - 软件技术</p>
      </Block>
    </>
  )
}
